((global) => {

  /**
  * Боковая панель настроек.
  *
  * @class WebAccess.components.AboutPanel
  * @extends WA.CMP.SidePanel
  * @since 5.8.3.9000
  */
  class AboutPanel extends WA.CMP.SidePanel {
    constructor() {
      super();

      this.headerString = L('ABOUT');
      this.initiator = '.AboutIco';
    };

    /**
     * Отображает боковую панель.
	   * @function WebAccess.components.AboutPanel.render
     * */
    render() {
      super.render();

      WA.SRV.request('api/UserSettings.asmx/GetAbout').done(result => {
        $('#sidepanel-body').append(`<div id="settings-body"></div>`);
        $('#settings-body').append(result.html);
        // Удалим заголовок блока, т.к. он уже есть на панели.
        $('.settings-block-name').remove();
      }).fail(() => {
        ShowError(L('SETTINGS_PANEL_SHOW_ERROR_MESSAGE'));
      });

      return this;
    };
  }

  global.AboutPanel = new AboutPanel();
})(window.WebAccess.components);